import React, { useState } from 'react';
import classNames from 'classnames';
import { Container } from '../../components/Container/Container';
import './CollapsibleHeader.css';
import { Icon } from '../../components/Icon/Icon';
import { Collapse } from '@nerdgeschoss/shimmer-component-collapse';

interface Props {
  title: string;
  children: React.ReactNode;
  onCollapseToggle: () => void;
}

export function CollapsibleHeader({ title, children, onCollapseToggle }: Props): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleCollapse = (): void => {
    setOpen((s) => !s);
    onCollapseToggle();
  };

  return (
    <Container isMobile>
      <div className="collapsible-header">
        <h1
          className={classNames('collapsible-header__overflowing-title', {
            'collapsible-header__overflowing-title--reset': open,
          })}
        >
          <strong>{title}</strong>
        </h1>
        <button className="collapsible-header__button" onClick={handleCollapse}>
          <Icon name={open ? 'arrow-line-up--sm' : 'arrow-line-down--sm'} />
        </button>
      </div>
      <Collapse open={open}>{children}</Collapse>
    </Container>
  );
}
